const middleware = {}

middleware['trueEscape'] = require('../middleware/trueEscape.js')
middleware['trueEscape'] = middleware['trueEscape'].default || middleware['trueEscape']

export default middleware
